import authorizeApi from './module/authorize'
import commonApi from './module/common'

// 统一注册API
const API = { ...authorizeApi, ...commonApi }

export default API
